import { type TaskBaseStatusEnum } from '@app/data/tasks/constants';

import { type TaskTemplateType } from './listTaskTemplates';

export const listTasks = `
query GetTasks(
  $leadUuid: String,
  $ownerUuid: String,
  $status: TaskBaseStatusEnum,
  $id: ID,
  $cursor: String,
  $limit: Int
) {
  tasks(
    leadUuid: $leadUuid,
    ownerUuid: $ownerUuid,
    status: $status,
    id: $id,
    cursor: $cursor,
    limit: $limit
  ) {
    tasks {
      id
      status
      startTime
      endTime
      completedOn
      subject
      description
      template {
        id
        name
        taskType
        defaultDueTime
      }
      config {
        calendarInviteForOrganizer
        calendarInviteForLead
        calendarInviteForOwner
      }
      reminderConfig {
        seconds
        beforeDays
        atTime
      }
      owner {
        userUuid
        email
        fullName
      }
      lead {
        leadUuid
      }
      organizer {
        userUuid
        email
        fullName
      }
      completedBy {
        userUuid
        email
        fullName
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
`;

export interface PageInfoType {
  hasNextPage: boolean;
  endCursor?: string;
}

export interface ReminderConfigType {
  seconds: number;
  beforeDays: number;
  atTime: string;
}

export interface TaskType {
  id: string;
  status: TaskBaseStatusEnum;
  startTime: string;
  endTime: string;
  completedOn: string;
  subject: string;
  description: string;
  reminderConfig?: ReminderConfigType;
  template: TaskTemplateType
  config: {
    calendarInviteForOrganizer: boolean;
    calendarInviteForLead: boolean;
    calendarInviteForOwner: boolean;
  }
  owner: {
    userUuid: string;
    email: string;
    fullName?: string;
  };
  lead: {
    leadUuid: string;
  };
  organizer: {
    userUuid: string;
    email: string;
    fullName?: string;
  };
  completedBy?: {
    userUuid: string;
    email: string;
    fullName?: string;
  };
}

export interface ListTasksResponseType {
  tasks: TaskType[];
  pageInfo: PageInfoType;
}
